import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
const drawerWidth = 240;
function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Shopify
      </Typography>
      <Divider />
      <List>
      
      <NavLink to="/">
          <Button variant='contained' sx={{color:"white",marginRight:"15px" }}>Home</Button>
          </NavLink>
          <NavLink to="/cart"><Button variant='contained' sx={{color:"white"}}>Cart</Button>
          </NavLink>
        
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            Shopify
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' }}}>
          <NavLink to="/">
          <Button variant='contained' sx={{color:"white",marginRight:"15px" }}>Home</Button>
          </NavLink>
          <NavLink to="/cart"><Button variant='contained' sx={{color:"white"}}>Cart</Button>
          </NavLink>
     
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main" sx={{ p: 0.1 }}>
        <Toolbar />
        
      </Box>
    </Box>
  );
}

Header.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Header;
